import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import FilterSidebar from 'components/search_sidebar/filter_sidebar';

export default class CallListSidebar extends React.Component {
  static propTypes = {
    activeCallListId: PropTypes.number,
    callLists: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
      })
    ).isRequired,
    onListClick: PropTypes.func.isRequired,
  };

  handleListClick = id => (e) => {
    e.preventDefault();
    this.props.onListClick(id);
  }

  render() {
    return (
      <FilterSidebar {...this.props}>
        <div className="call-lists-sidebar border-end h-100 py-3" style={{ width: "200px" }}>
          <ul className="list-unstyled px-5">
            {
              this.props.callLists.map((callList) => {
                const className = classNames({
                  'call-list-item p-2': true,
                  'clickable': true,
                  'rounded': true,
                  'my-2': true,
                  'selected-call-list-item': this.props.activeCallListId === callList.id
                });

                return (
                  <li
                    className={className}
                    key={`call-list-${callList.id}`}
                    onClick={this.handleListClick(callList.id)}
                  >
                    {callList.name}
                  </li>
                );
              })
            }
          </ul>
        </div>
      </FilterSidebar>
    );
  }
}
